define('view/controller/booking/provider/ProviderFilterView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Provider Filter View
     *
     * @class ProviderFilterView
     */
    return LayoutView.extend({

        template: '#provider_filter_view',

        ui: {
            input: '.sb-input'
        },

        events: {
            'keyup @ui.input': 'onInputChange',
            'change @ui.input': 'onInputChange',
        },

        onInputChange: function () {
            var query = this.ui.input.val();
            this.model.set('query', query);
        }

    });

});
